import { useCallback, useEffect, useState } from "react";
import { CeresMark } from "@/components/ceres/CeresMark";

const LETTERS = "CERES".split("");
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Intro: the Harvest "H" mark is ringed in orange, gives way to the Ceres wheat ear, then the name sets in.
export const CeresIntro = ({ onDone }) => {
  const [leaving, setLeaving] = useState(false);

  const finish = useCallback(() => {
    setLeaving(true);
    setTimeout(onDone, 650);
  }, [onDone]);

  useEffect(() => {
    if (reduced()) return onDone();
    const tm = setTimeout(finish, 3900);
    const onKey = (e) => (e.key === "Escape" || e.key === "Enter") && finish();
    window.addEventListener("keydown", onKey);
    return () => { clearTimeout(tm); window.removeEventListener("keydown", onKey); };
  }, [finish, onDone]);

  return (
    <div className={`ceres-intro fixed inset-0 z-[60] flex flex-col items-center justify-center overflow-hidden ${leaving ? "ceres-intro-leave" : ""}`}
      role="presentation" data-testid="ceres-intro">
      <div className="ceres-grain-field" aria-hidden="true" />
      <div className="relative flex items-center">
        <div className="ceres-stage relative h-[110px] w-[110px] sm:h-[180px] sm:w-[180px]">
          <img src="/brand/etf-icon.png" alt="" className="ceres-h-icon absolute inset-[22%] rounded-full bg-white" />
          <CeresMark animate delay={700} className="absolute inset-0 h-full w-full" tone="dark" />
          <span className="ceres-pulse absolute inset-0 rounded-full" aria-hidden="true" />
        </div>
        <div className="ceres-word ml-3 overflow-hidden sm:ml-6">
          <p className="flex font-heading text-4xl font-extrabold tracking-[0.16em] text-white sm:text-7xl" aria-label="Ceres">
            {LETTERS.map((l, i) => (
              <span key={i} className="ceres-letter inline-block" style={{ animationDelay: `${1900 + i * 70}ms` }}>{l}</span>
            ))}
          </p>
          <p className="ceres-fade mt-2 font-heading text-[11px] font-semibold uppercase tracking-[0.32em] text-hv-orange sm:text-[13px]" style={{ animationDelay: "2400ms" }}>
            Harvest's fund guide
          </p>
        </div>
      </div>
      <div className="ceres-fade mt-14 flex items-center gap-3 bg-white px-5 py-3" style={{ animationDelay: "2700ms" }}>
        <span className="font-heading text-[10px] font-semibold uppercase tracking-[0.2em] text-hv-muted">Presented by</span>
        <img src="/brand/etf-header.svg" alt="Harvest ETFs" className="h-5 w-auto" />
      </div>
      <button type="button" onClick={finish} data-testid="ceres-intro-skip-button"
        className="absolute bottom-6 right-6 border-2 border-white/70 px-4 py-2 font-heading text-[11px] font-semibold uppercase tracking-[0.18em] text-white transition-colors hover:bg-white hover:text-hv-navy">
        Skip intro
      </button>
    </div>
  );
};
